import { useInView } from "react-intersection-observer";
import {
  motion,
  useViewportScroll,
  useTransform,
} from "framer-motion";
import Espontaneo from "../../../images/scroll-fixed/slide1/se-espontaneo.png";
import Encuentrate from "../../../images/scroll-fixed/slide2/encuentrate-con-duda.svg";
import MundoPremium from "../../../images/scroll-fixed/slide3/mundo-premium.svg";
import { Link } from "react-router-dom";

const ScrollFixed = () => {
  const { ref: bgRef, inView: isVisibleBg } = useInView({
    rootMargin: "-10px",
  });
  const { ref: scene1Ref, inView: isVisibleScene1 } = useInView({
    rootMargin: "-300px",
    triggerOnce: false,
  });
  const { ref: scene2Ref, inView: isVisibleScene2 } = useInView();
  const { scrollYProgress } = useViewportScroll();
  const yCenterScene1 = useTransform(
    scrollYProgress,
    [0, 0.09, 0.15],
    [0, -20, -600]
  );
  const opacityScene1 = useTransform(scrollYProgress, [0.09, 0.12], [1, 0]);
  const yImg4 = useTransform(scrollYProgress, [0, 0.09, 0.2], [0, -20, -1800]);
  const yCenterScene2 = useTransform(
    scrollYProgress,
    [0.09, 0.15, 0.35],
    [120, -400, -1200]
  );
  const yCenterScene3 = useTransform(
    scrollYProgress,
    [0.15, 0.25],
    [-400, -400]
  );

  return (
    <div className="container-scroll-fixed">
      {/* BACKGROUND */}
      <motion.div
        ref={bgRef}
        className="background"
        initial={{
          opacity: 0,
        }}
        animate={
          isVisibleBg && {
            opacity: 1,
          }
        }
        transition={{ duration: 2 }}
      >
        <div className="circle1"></div>
        <div className="circle2"></div>
        <div className="circle3"></div>
        <div className="circle4"></div>
        <div className="circle5"></div>
      </motion.div>
      <div className="scroll-fixed">
        {/* SCENE 1 */}
        <div className="scene" ref={scene1Ref}>
          <motion.div
            className="text-content"
            style={
              isVisibleScene2
                ? { y: yCenterScene1, opacity: opacityScene1 }
                : { y: yCenterScene1 }
            }
            initial={{
              opacity: 0,
            }}
            animate={
              isVisibleScene1 && {
                opacity: 1,
              }
            }
            transition={{ duration: 2 }}
          >
            <img className="img1" src={Espontaneo} />
            <h2>
              TIÉNTATE CON <font>XD NEO</font>
            </h2>
            <span className="text-down">
              Scroll
              <svg
                width="20"
                height="33"
                viewBox="0 0 20 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <motion.rect
                  x="8"
                  y="6"
                  width="4"
                  height="4"
                  rx="4"
                  fill="white"
                  animate={{ y: [9, 0, 9], opacity: [0, 1, 0] }}
                  transition={{
                    duration: 1.9,
                    times: [0.1, 0.5, 0.9],
                    yoyo: Infinity,
                  }}
                />
                <motion.rect
                  x="1"
                  y="1"
                  width="18"
                  height="31"
                  rx="9"
                  stroke="white"
                  stroke-width="2"
                />
              </svg>
              down
            </span>
          </motion.div>
          <motion.div
            className="image1 backg-img"
            style={
              isVisibleScene2
                ? { y: yCenterScene1, opacity: opacityScene1 }
                : { y: yCenterScene1 }
            }
            initial={{
              opacity: 0,
              marginTop: 200,
            }}
            animate={
              isVisibleScene1 && {
                opacity: 1,
                marginTop: 0,
              }
            }
            transition={{ duration: 2 }}
          />
          <motion.div
            className="image2 backg-img"
            style={
              isVisibleScene2
                ? { y: yCenterScene1, opacity: opacityScene1 }
                : { y: yCenterScene1 }
            }
            initial={{
              opacity: 0,
              marginTop: 100,
            }}
            animate={
              isVisibleScene1 && {
                opacity: 1,
                marginTop: 0,
              }
            }
            transition={{ duration: 2 }}
          />
          <motion.div
            className="image3 backg-img"
            style={
              isVisibleScene2
                ? { y: yCenterScene1, opacity: opacityScene1 }
                : { y: yCenterScene1 }
            }
            initial={{
              opacity: 0,
              marginTop: 200,
            }}
            animate={
              isVisibleScene1 && {
                opacity: 1,
                marginTop: 0,
              }
            }
            transition={{ duration: 2 }}
          />
          <motion.div
            className="image4 backg-img"
            style={
              isVisibleScene2
                ? { y: yImg4, opacity: opacityScene1 }
                : { y: yImg4 }
            }
            initial={{
              opacity: 0,
              marginBottom: "-200px",
            }}
            animate={
              isVisibleScene1 && {
                opacity: 1,
                marginBottom: 0,
              }
            }
            transition={{ duration: 2 }}
          />
          <motion.div
            className="image5 backg-img"
            style={
              isVisibleScene2
                ? { y: yCenterScene1, opacity: opacityScene1 }
                : { y: yCenterScene1 }
            }
            initial={{
              opacity: 0,
            }}
            animate={
              isVisibleScene1 && {
                opacity: 1,
              }
            }
            transition={{ duration: 2 }}
          />
        </div>

        {/* SCENE 2 */}
        <motion.div
          ref={scene2Ref}
          className="scene scene2"
          style={{ y: yCenterScene2 }}
        >
          <div className="text-scene">
            <img className="encuentrate" src={Encuentrate} />
            <h2 className="text-title">
              DE NO SABER CON CUÁL DE LOS MÁS DE 100 CANALES ENTRETENERTE.
            </h2>
            <div className="btns-scene">
              <Link to="/canales" className="button button-primary">
                Ver canales
              </Link>
              <Link to="/guia" className="button button-transparent">
                Explorar guía
              </Link>
            </div>
          </div>
          <div className="channel logo1">
            <div className="img"></div>
          </div>
          <div className="channel logo2">
            <div className="img"></div>
          </div>
          <div className="channel logo3">
            <div className="img"></div>
          </div>
          <div className="channel logo4">
            <div className="img"></div>
          </div>
          <div className="channel logo5">
            <div className="img"></div>
          </div>
          <div className="channel logo6">
            <div className="img"></div>
          </div>
          <div className="channel logo7">
            <div className="img"></div>
          </div>
        </motion.div>

        {/* SCENE 3 */}
        <motion.div className="scene scene3" style={{ y: yCenterScene3 }}>
          <div className="text-scene">
            <img className="mundo-premium" src={MundoPremium} />
            <h2 className="text-title">
              PARA DISFRUTAR DEL CONTENIDO MÁS EXCLUSIVO DE TODOS.
            </h2>
            <div className="btns-scene">
              <Link to="/canales" className="button button-primary">
                Ver canales
              </Link>
              <Link to="/guia" className="button button-transparent">
                Explorar guía
              </Link>
            </div>
          </div>
          <div className="channels">
            <div className="channel margin">
              <div className="logo1"></div>
            </div>
            <div className="channel">
              <div className="logo2"></div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default ScrollFixed;
